import { group1Articles } from "./group1";
import { group2Articles } from "./group2";
import { group3Articles } from "./group3";
import { group4Articles } from "./group4";
import { Article } from "./types";

export * from "./types";

export const PASTOR_IMAGES = {
  SERGE_JOSEPH:
    "https://ik.imagekit.io/4apzi8lz0/egarizim/pasteur-femme.png?updatedAt=1760916546786",
  OTHNIEL_JOSEPH:
    "https://ik.imagekit.io/4apzi8lz0/egarizim/othniel.jpg?updatedAt=1760896561970",
  SERGE_JOSEPH_JR:
    "https://ik.imagekit.io/4apzi8lz0/egarizim/serge-junior.jpg?updatedAt=1760896562157",
  JIMMY_JEANTY:
    "https://ik.imagekit.io/4apzi8lz0/egarizim/jimmy.jpg?updatedAt=1760896561686",
};

export const getAuthorImage = (
  authorName: string,
  explicitImage?: string
): string | undefined => {
  if (explicitImage) return explicitImage;
  const lower = authorName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  if (lower.includes("othniel")) {
    return PASTOR_IMAGES.OTHNIEL_JOSEPH;
  }
  if (lower.includes("junior") || lower.includes("jr")) {
    return PASTOR_IMAGES.SERGE_JOSEPH_JR;
  }
  if (lower.includes("jimmy") || lower.includes("jeanty")) {
    return PASTOR_IMAGES.JIMMY_JEANTY;
  }
  if (lower.includes("serge") || lower.includes("joseph")) {
    return PASTOR_IMAGES.SERGE_JOSEPH;
  }

  return undefined;
};

export const allArticles: Article[] = [
  ...group1Articles,
  ...group2Articles,
  ...group3Articles,
  ...group4Articles,
].sort((a, b) => (a.isoDate < b.isoDate ? 1 : -1));

export const getArticleBySlug = (slug: string): Article | undefined => {
  return allArticles.find((art) => art.slug.toLowerCase() === slug.toLowerCase());
};

export const getRelatedArticles = (currentId: string, limit = 3): Article[] => {
  const current = allArticles.find((art) => art.id === currentId);
  if (!current) return allArticles.slice(0, limit);

  return allArticles
    .filter((art) => art.id !== currentId)
    .sort((a, b) => {
      if (a.category === current.category && b.category !== current.category) return -1;
      if (b.category === current.category && a.category !== current.category) return 1;
      return 0;
    })
    .slice(0, limit);
};

export const getArticleCategories = (): string[] => {
  const categories = new Set<string>();
  allArticles.forEach((art) => categories.add(art.category));
  return Array.from(categories);
};

export interface ArticleAuthor {
  id: string;
  name: string;
  role: string;
  image?: string;
}

export const getArticleAuthors = (): ArticleAuthor[] => {
  const predefined: ArticleAuthor[] = [
    {
      id: "serge-joseph",
      name: "Pasteur Serge Joseph",
      role: "Pasteur Fondateur",
      image: PASTOR_IMAGES.SERGE_JOSEPH,
    },
    {
      id: "othniel-joseph",
      name: "Pasteur Othniel Joseph",
      role: "Pasteur Titulaire",
      image: PASTOR_IMAGES.OTHNIEL_JOSEPH,
    },
    {
      id: "jimmy-jeanty",
      name: "Pasteur Jimmy Jeanty",
      role: "Pasteur Associé",
      image: PASTOR_IMAGES.JIMMY_JEANTY,
    },
    {
      id: "serge-joseph-jr",
      name: "Pasteur Serge Joseph Jr.",
      role: "Pasteur Associé",
      image: PASTOR_IMAGES.SERGE_JOSEPH_JR,
    },
  ];

  const seenIds = new Set(predefined.map((a) => a.id));
  const result = [...predefined];

  allArticles.forEach((article) => {
    const author = article.author;
    const authorLower = author.toLowerCase();
    const isCovered =
      authorLower.includes("serge") ||
      authorLower.includes("othniel") ||
      authorLower.includes("jimmy");
    if (!isCovered) {
      const id = author.toLowerCase().replace(/[^a-z0-9]/g, "-");
      if (!seenIds.has(id)) {
        seenIds.add(id);
        result.push({
          id,
          name: author,
          role: article.authorRole || "Auteur",
          image: getAuthorImage(author, article.authorImage),
        });
      }
    }
  });

  return result;
};

